import React from 'react';
import {
  mobile,
  // tablet
} from '../../../utils/deviceWidths';

/* Components */
import Loader from '../Loader/Loader';
/* Styles */
import './LazyImage.scss';

/* Props */
interface LazyImageProps {
  handleRouteChange?: any;
  onClick?: (e: MouseEvent<HTMLInputElement>) => void;
  imgSrc?: string;
  imgHeight?: number;
  imgWidth?: number;
  imgAlt?: string;
  imgLink?: string;
  isVideo?: boolean;
  fallbackImage?: string;
  linkCategory?: string | null;
  containerWidth?: number | null;
  twoButton?: boolean;
  backgroundColor?: string;
  halfWidth?: boolean;
  onPromotionClick?: any;
  className?: string;
  style?: any;
  promotionId?: string;
}

class LazyImage extends React.PureComponent<LazyImageProps, {}> {
  constructor(props) {
    super(props);
    this.state = { imgLoaded: false };
  }

  handleImageLink = e => {
    const {
      imgAlt,
      imgLink,
      linkCategory,
      handleRouteChange,
      onClick,
      onPromotionClick,
      promotionId,
    } = this.props;

    e.preventDefault();
    if (onPromotionClick && promotionId) {
      onPromotionClick(e, promotionId, 'Single Image Banner', imgAlt);
    }

    if (onClick) {
      return onClick(e);
    }

    if (handleRouteChange) {
      handleRouteChange(imgLink, linkCategory);
    }
  };

  handleImageLoaded = () => {
    this.setState(prevState => ({
      imgLoaded: !prevState.imgLoaded,
    }));
  };

  imageAlreadyLoaded = () => {
    return 'already loaded';
  };

  handleImageError = () => {
    this.setState(() => ({
      imgLoaded: 'failed to load',
    }));
  };

  render() {
    const {
      imgSrc,
      imgHeight,
      imgWidth,
      imgAlt,
      backgroundColor,
      isVideo,
      fallbackImage,
      containerWidth,
      halfWidth,
      twoButton,
    } = this.props;
    const { imgLoaded } = this.state;
    const paddingRatio = (imgHeight / imgWidth) * 100;
    const paddingBottom = `${paddingRatio}%`;
    const loaderPadding = paddingRatio / 2;
    const isClickable = !!this.props.onClick || !!this.props.handleRouteChange;
    const className = halfWidth
      ? 'lazyImage-container-halfWidth'
      : isClickable
        ? 'lazyImage-container'
        : 'lazyImage-containerStatic';
    // const isAndroid = /(android)/i.test(navigator.userAgent);
    const isMobile = containerWidth <= mobile;
    const mediaSrc = isVideo && isMobile ? fallbackImage : imgSrc;
    return (
      <div className={className} style={{ backgroundColor, paddingBottom }}>
        <div>
          {halfWidth || twoButton ? null : !imgLoaded ? (
            <Loader loaderPadding={loaderPadding} />
          ) : null}
          {isVideo && !isMobile ? (
            <div>
              <video
                src={mediaSrc}
                muted
                loop
                // controls
                autoPlay
                poster={fallbackImage || null}
                onClick={this.handleImageLink}
                onLoadStart={
                  imgLoaded ? this.imageAlreadyLoaded : this.handleImageLoaded
                }
                onError={this.handleImageError}
                width="100%"
              />
            </div>
          ) : (
            <img
              alt={imgAlt}
              src={mediaSrc}
              onClick={this.handleImageLink}
              onLoad={this.handleImageLoaded}
              onError={this.handleImageError}
            />
          )}
        </div>
      </div>
    );
  }
}

export default LazyImage;
